export const water = {
  src: require('../../../../../assets/img/icons/water.svg'),
  tip: 'wasserdicht',
  id: 1
}

export const sun = {
  src: require('../../../../../assets/img/icons/sun.svg'),
  tip: 'UV-stabilisiert',
  id: 2
}

export const fire = {
  src: require('../../../../../assets/img/icons/fire.svg'),
  tip: 'schwer entflammbar',
  id: 3
}
